// src/stage2/Life Meters/RingCounter.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import "./lifeMeter.css";

export default function RingCounter({ current = 0, top = 0, last = 0 }) {
  const prevRef = useRef(current);
  const [burstId, setBurstId] = useState(0);

  // For a quick "counter bounce" when current changes
  const [pulse, setPulse] = useState(false);

  // Generate a tiny one-shot animation trigger each time we gain rings
  useEffect(() => {
    const prev = prevRef.current;

    if (current > prev) {
      // Trigger HUD pulse
      setPulse(true);
      window.setTimeout(() => setPulse(false), 260);

      // Trigger fly-to-HUD ring + "+1" pop
      setBurstId((n) => n + 1);
    }

    prevRef.current = current;
  }, [current]);

  // Simple ring SVG so you don’t need an image asset
  const RingIcon = useMemo(() => {
    return (
      <svg
        className="ring-icon"
        viewBox="0 0 64 64"
        aria-hidden="true"
        focusable="false"
      >
        {/* outer glow */}
        <defs>
          <radialGradient id="ringGlow" cx="50%" cy="35%" r="70%">
            <stop offset="0%" stopColor="#fff6b0" />
            <stop offset="55%" stopColor="#ffd34f" />
            <stop offset="100%" stopColor="#c88a00" />
          </radialGradient>
        </defs>

        {/* ring body */}
        <circle cx="32" cy="32" r="22" fill="none" stroke="url(#ringGlow)" strokeWidth="10" />
        {/* highlight */}
        <path
          d="M18 24c4-7 14-11 22-7"
          fill="none"
          stroke="rgba(255,255,255,.85)"
          strokeWidth="4"
          strokeLinecap="round"
        />
      </svg>
    );
  }, []);

  return (
    <div className={`meter ring-counter ${pulse ? "rc-pulse" : ""}`}>
      {/* Fly-to-HUD burst (ring + +1) */}
      {/* key forces restart of CSS animation */}
      <div className="rc-burst-layer" aria-hidden="true">
        <div key={burstId} className="rc-burst">
          <div className="rc-fly-ring">{RingIcon}</div>
          <div className="rc-plus">+1</div>
          <div className="rc-spark" />
        </div>
      </div>

      {/* Row 1: Title + main count */}
      <div className="ring-row ring-row-top">
        {/* <div className="meter-title">Rings of Encouragement</div> */}

        <div className="ring-count">
          <span className="ring-count-icon">{RingIcon}</span>
          <span className="ring-value">x{current}</span>
        </div>
      </div>

      {/* Row 2: fine print */}
      <div className="ring-row ring-row-fine">
        <span className="ring-label">Your Last: {last}</span>
        <span className="ring-sep">|</span>
        <span className="ring-label">Your Best: {top}</span>
      </div>
    </div>
  );
}
